(function() {
'use strict';

angular
    .module('quote')
    .controller('Quote', Quote);

function Quote(quoteService,
               tripService,
               bookingService,
               hotelRehydrator,
               $routeParams,
               $location,
               $filter,
               dateUtil,
               flightDetail,
               $q) {
    const qc = this;
    qc.quoteCreationError = false;
    qc.quoteNotFound = false;
    qc.quoteRefreshEnabled = TRPCONFIG.Domain.QuoteRefreshEnabled;
    qc.quoteManager = !($routeParams.quoteRef && $routeParams.quoteNo);
    qc.quoteRefreshError = false;
    qc.validForDays = 30; //maybe the API should tell us this

    if (!qc.quoteManager) {
        quoteService.getQuoteByReference(`${$routeParams.quoteRef}/${$routeParams.quoteNo}`).then(function(result) {
            if (result === null) {
                qc.quoteNotFound = true;
            } else {
                qc.quote = result;
                if (!qc.quote) {
                    qc.quoteNotFound = true;
                } else {
                    qc.validForDays = quoteService.validForDays(qc.quote.Products);
                    enrichProducts();
                }
            }
        });
    }

    const productNames = {
        accommodation: 0,
        flight: 1,
        transfer: 2,
        airportparking: 3,
        attractionticket: 4,
        carhire: 5,
        marhaba: 6,
        insurance: 7
    };


    function getNumFromType(type) {
        const typeStr = type.toLowerCase().replace(/\s/g, '');
        return productNames[typeStr] >= 0 ? productNames[typeStr] : Object.keys(productNames).length;
    }

    function sortProducts(products) {
        const sorted = products && products.sort(function(a, b) {
            const typeA = getNumFromType(a.Type);
            const typeB = getNumFromType(b.Type);

            a.TypeId = typeA;
            b.TypeId = typeB;

            return typeA > typeB ? 1 : -1;
        });

        return sorted;
    }

    qc.refreshQuote = function() {
        qc.refreshClicked = true;
        qc.quoteRefreshError = false;
        return quoteService.refreshQuote(qc.quote.Id, qc.quote.ProductIds).then(result => {
            qc.refreshClicked = false;
            if (result.Error) {
                qc.quoteRefreshError = true;
            } else {
                qc.quote = result;

                if (!qc.quote) {
                    qc.quoteNotFound = true;
                    qc.quoteCreationError = true;
                } else {
                    qc.validForDays = quoteService.validForDays(qc.quote.Products);
                    return enrichProducts();
                }
            }
        });
    };

    qc.getQuoteByReference = function(quoteRef, quoteNo) {
        $location.path(`quote/manage/${quoteRef}/${quoteNo}`);
    };

    qc.replaceProduct = function(quoteId, productId, replacementId) {
        quoteService.replaceProduct(quoteId, productId, replacementId).then(function(result) {
            qc.quote = result;
            if (!qc.quote) {
                qc.quoteNotFound = true;
                qc.quoteCreationError = true;
            } else {
                qc.validForDays = quoteService.validForDays(qc.quote.Products);
                enrichProducts();
            }
        });
    };

    qc.gotoBasket = () => $location.path('dp/basket');

    qc.bookQuote = () => {
        //redirection url
        let bookingRedirectPath = 'holidays/book';
        if (qc.quote.Products && qc.quote.Products.length === 1) {
            if (qc.quote.Products[0].Type === 'Accommodation') {
                bookingRedirectPath = 'hotels/book';
            } else if (qc.quote.Products[0].Type === 'Transfer') {
                bookingRedirectPath = 'transfers/book';
            } else if (qc.quote.Products[0].Type === 'Marhaba') {
                bookingRedirectPath = 'marhaba/book';
            } else if (qc.quote.Products[0].Type === 'Insurance') {
                bookingRedirectPath = 'insurance/book';
            } else if (qc.quote.Products[0].Type === 'Airport Parking') {
                bookingRedirectPath = 'parking/book';
            }
        }
        //get trip
        tripService.getTripFromQuote(qc.quote).then(result => {
            qc.tripFromQuote = result;
            bookingService.prepareBooking(qc.quote.BasketId, qc.tripFromQuote.BookingId, qc.tripFromQuote.TripId)
                .then(() => {
                    if (bookingRedirectPath === 'marhaba/book') {
                        $location.path(`marhaba/book/${qc.tripFromQuote.TripId}/${qc.quote.Products[0].Id}`);
                    } else {
                        $location.path(`${bookingRedirectPath}/${qc.tripFromQuote.TripId}`);
                    }
                });
        });
    };

    qc.searchAgain = () => {
        //select tab from search unit
        let searchRedirectPath = '/holidays';
        if (qc.quote.Products.length === 1) {
            searchRedirectPath = qc.quote.Products[0].searchRedirectPath;
        }
        //get trip id
        tripService.getTripFromQuote(qc.quote).then(function(result) {
            qc.tripFromQuote = result;
            if (qc.tripFromQuote) {
                tripService.restoreSearchUnit(qc.tripFromQuote.TripId).then(function() {
                    $location.path(searchRedirectPath);
                });
            } else {
                document.location.href = '/';
            }
        });
    };

    function getDetailsForAllFlights(products) {
        return $q.all(products
            .map(p => {
                return p.Type === 'Flight'
                    ? flightDetail.mapLegs(p)
                    : $q.when(p);
            }));
    }


    function enrichProducts() {
        return getDetailsForAllFlights(qc.quote.Products)
            .then(p => {
                const products = sortProducts(p);
                qc.quote.ProductIds = [];
                qc.quote.RestoreFailed = false;
                qc.quote.totalQuotedHolidayCost = 0;
                qc.quote.totalCurrentHolidayCost = 0;
                qc.failedRestore = products && products.filter(p => p.RestoreFailed);

                angular.forEach(products, product => {
                    qc.quote.ProductIds.push(product.Id);
                    if (product.RestoreFailed) {
                        qc.quote.RestoreFailed = true;
                    }
                    if (product.Type === 'Flight') {
                        product.iconClass = 'icon-flights';
                        getFlightDetails(product);
                        product.searchRedirectPath = '/flights';
                    } else if (product.Type === 'Accommodation') {
                        product.iconClass = 'icon-hotels';
                        getHotelDetails(product);
                        product.searchRedirectPath = '/hotels';
                        if (Array.isArray(product.SpecialOffers)) {
                            product.HasSpecialOffers = product.SpecialOffers.some(so => so);
                        }
                    } else if (product.Type === 'Transfer') {
                        product.iconClass = 'icon-transfers';
                        product.searchRedirectPath = '/transfers';
                    } else if (product.Type === 'Car Hire') {
                        product.searchRedirectPath = '/car-hire';
                        getCarHireDetails(product);
                    } else if (product.Type === 'Marhaba') {
                        if (product.Options.length > 0) {
                            getTotalProductCost(product);
                        }
                        product.searchRedirectPath = '/marhaba';
                    } else if (product.Type === 'Insurance') {
                        product.searchRedirectPath = '/insurance';
                    }
                    qc.quote.totalQuotedHolidayCost += product.TotalQuotedCost ? product.TotalQuotedCost : product.QuotedCost;
                    qc.quote.totalCurrentHolidayCost += product.TotalCurrentCost ? product.TotalCurrentCost : product.CurrentCost;
                });
                qc.quote.Products = products;
            });
    }

    function getCarHireDetails(product) {
        angular.forEach(product.Options, option => {
            if (option.OnRequest) {
                product.ShowOnRequest = true;
            }
            option.PayableLocally = (option.CurrentUnitCost === 0 && option.QuotedUnitCost === 0 && option.Quantity >= 1 && option.OnRequest === true);

            option.UnitCurrentAmountString = $filter('customCurrency')(option.CurrentUnitCost, option.Currency);
            option.TotalCurrentAmountString = $filter('customCurrency')((option.CurrentUnitCost * option.Quantity), option.Currency);
        });
    }

    function getFlightDetails(product) {
        getTotalProductCost(product);

        product.Options = _.filter(product.Options, function(option) {
            const title = `${parseInt(option.Title)}`;
            return option.CurrentOptionCost > 0 || option.Title !== title;
        });
    }

    function getHotelDetails(product) {
        hotelRehydrator.staticHotel(product.EstablishmentId).then(function(d) {
           product.extraDetails = d;
       });
    }

    function getTotalProductCost(product) {
        let totalQuotedProductCost = 0;
        let totalCurrentProductCost = 0;

        angular.forEach(product.Options, option => {
            option.CurrentOptionCost = option.Quantity * option.CurrentUnitCost;
            option.QuotedOptionCost = option.Quantity * option.QuotedUnitCost;

            totalQuotedProductCost += option.QuotedOptionCost;
            totalCurrentProductCost += option.CurrentOptionCost;

            option.UnitCurrentAmountString = $filter('customCurrency')(option.CurrentUnitCost);
            option.TotalCurrentAmountString = $filter('customCurrency')((option.CurrentUnitCost * option.Quantity));
        });

        product.TotalCurrentCost = product.CurrentCost + totalCurrentProductCost;
        product.TotalQuotedCost = product.QuotedCost + totalQuotedProductCost;
    }
}
})();
